import { InjectionToken } from '@angular/core';

export const APPLICATION_NAME = new InjectionToken<string>('APPLICATION_NAME');
